module.exports = __webpack_public_path__ + "img/bv.78bef910.svg";